/* OTUNBA — mobile announcement bar bullet rotator
 *
 * The announcement bar renders as one <p> with bullet-separated text:
 *   "Bespoke Couture · Made to Order · Worldwide White-Glove Delivery"
 * On desktop that fits one line; on mobile (< 750px) it wraps and looks
 * congested. This script splits the text into separate items and rotates
 * through them one at a time, mobile only. Desktop is untouched.
 *
 * Approach:
 *   1. On DOMContentLoaded, check viewport width.
 *   2. If mobile (< 750px): find .announcement-bar__message span,
 *      split text on " · ", replace with a rotator container of <span>s.
 *   3. Inject a tiny <style> with the @media-scoped keyframes animation.
 *   4. Re-evaluate on window resize so rotating in/out of mobile width
 *      restores the original markup (or rebuilds the rotator).
 */
(function () {
  if (window.__otunbaAnnounceRotator) return;
  window.__otunbaAnnounceRotator = true;

  var SEPARATOR = /\s*·\s*/;          // matches " · " with surrounding whitespace
  var CYCLE_PER_ITEM_MS = 3000;       // each item visible for ~3s
  var MOBILE_MAX_PX = 749;

  // Inject the CSS once. Scoped via @media so it only matters on mobile.
  function injectStyles() {
    if (document.getElementById('otunba-announce-rotator-style')) return;
    var css =
      '@media (max-width: ' + MOBILE_MAX_PX + 'px) {' +
        '.otunba-announce-rotator{' +
          'display:inline-block!important;' +
          'position:relative!important;' +
          'min-height:1.4em;' +
          'min-width:200px;' +
          'vertical-align:middle;' +
        '}' +
        '.otunba-announce-rotator > span{' +
          'display:block;' +
          'position:absolute;' +
          'top:0;left:50%;' +
          'transform:translate(-50%,8px);' +
          'opacity:0;' +
          'white-space:nowrap;' +
          'animation:otunba-announce-cycle var(--cycle-total,9s) infinite;' +
        '}' +
        '@keyframes otunba-announce-cycle{' +
          '0%{opacity:0;transform:translate(-50%,8px);}' +
          '4%,30%{opacity:1;transform:translate(-50%,0);}' +
          '34%,100%{opacity:0;transform:translate(-50%,-8px);}' +
        '}' +
      '}';
    var s = document.createElement('style');
    s.id = 'otunba-announce-rotator-style';
    s.textContent = css;
    document.head.appendChild(s);
  }

  // Build the rotator inside a given <span> (the text container).
  function rebuildAsRotator(msgSpan) {
    // Save the original combined text on the parent so we can restore
    // it later if the viewport grows back to desktop.
    var p = msgSpan.parentNode;
    if (!p.dataset.otunbaOriginal) {
      p.dataset.otunbaOriginal = msgSpan.textContent;
    }
    var parts = (p.dataset.otunbaOriginal || msgSpan.textContent).split(SEPARATOR).map(function(s){ return s.trim(); }).filter(Boolean);
    if (parts.length < 2) return;

    var container = document.createElement('span');
    container.className = 'otunba-announce-rotator';
    container.style.setProperty('--cycle-total', (parts.length * CYCLE_PER_ITEM_MS / 1000) + 's');

    parts.forEach(function (text, i) {
      var item = document.createElement('span');
      item.textContent = text;
      // Stagger each item's animation delay so they appear in sequence.
      item.style.animationDelay = (i * CYCLE_PER_ITEM_MS / 1000) + 's';
      container.appendChild(item);
    });

    msgSpan.replaceWith(container);
  }

  // Restore the original combined text (used when going from mobile to desktop).
  function restoreOriginal(p) {
    var original = p.dataset.otunbaOriginal;
    if (!original) return;
    var existingRotator = p.querySelector('.otunba-announce-rotator');
    if (!existingRotator) return;
    var s = document.createElement('span');
    s.textContent = original;
    existingRotator.replaceWith(s);
  }

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX_PX;
  }

  function apply() {
    var messages = document.querySelectorAll('.announcement-bar__message');
    messages.forEach(function (p) {
      if (isMobile()) {
        // If a rotator already exists, leave it. Otherwise build one.
        if (p.querySelector('.otunba-announce-rotator')) return;
        var span = p.querySelector('span');
        if (!span) return;
        rebuildAsRotator(span);
      } else {
        // Desktop — restore single span if we previously built a rotator.
        if (p.querySelector('.otunba-announce-rotator')) restoreOriginal(p);
      }
    });
  }

  function init() {
    injectStyles();
    apply();
    // Re-evaluate on viewport changes (e.g., orientation change).
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
